import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { ManageBulkProcessState, SelectedBulkProcessDetails } from "./model";

const initialState: ManageBulkProcessState = {
  selectedBulkProcess: {
    bulkProgramImportId: "",
    processName: "",
    processDate: "",
    category: {
      categoryId: "",
      categoryName: "",
    },
    status: "",
  },
};

const manageBulkProcessSlice = createSlice({
  name: "manageBulkProcessSlice",
  initialState,
  reducers: {
    setSelectedBulkProcess: (
      state,
      action: PayloadAction<SelectedBulkProcessDetails>,
    ) => {
      state.selectedBulkProcess = action.payload;
    },
    resetSelectedBulkProcess: (
      state,
      action: PayloadAction<SelectedBulkProcessDetails>,
    ) => {
      state.selectedBulkProcess = initialState.selectedBulkProcess;
    },
  },
});

export const { setSelectedBulkProcess, resetSelectedBulkProcess } =
  manageBulkProcessSlice.actions;

export const persistManageBulkProcessConfig = {
  version: 1,
  key: "mpg_next_admin_program_v1",
  storage,
  whitelist: [],
};

export default manageBulkProcessSlice.reducer;
